export enum FitCcInputTypes {
  TEXT = 'TEXT',
  PERCENTAGE = 'PERCENTAGE',
  GEOGRAPHY = 'GEOGRAPHY',
  DECIMAL = 'DECIMAL',
  DATETIME = 'DATETIME',
  CURRENCY = 'CURRENCY',
  INTEGER = 'INTEGER',
}
